<template>

    <div class="comment-item cf">

        <div class="avatar fl">

            <v-image class="avatar-img" radius="50%" :src="data.head_pic || require('../../assets/images/avatar.png')" />

        </div>

        <div class="comment-input fr">

            <div class="comment-user cf">

                <div class="fl">{{ data.nick_name }}</div>

                <div class="fr">{{ data.create_time }}</div>

            </div>

            <div class="comment-text">{{ data.content }}</div>

            <div
                class="comment-item cf"
                style="border-bottom: none;"
                v-for="(item,index) in reply"
                :key="'comment-item-reply-'+index"
            >

                <div class="avatar fl">

                    <v-image class="avatar-img" radius="50%" :src="item.head_pic || require('../../assets/images/avatar.png')" />

                </div>

                <div class="comment-input fr" style="width: 630px;">

                    <div class="comment-user cf">

                        <div class="fl">{{ item.nick_name }}</div>

                        <div class="fr">{{ item.create_time }}</div>

                    </div>

                    <div class="comment-text">{{ item.content }}</div>

<!--                    <div class="comment-reply" @click="is_reply = !is_reply;">回复</div>-->

                </div>

            </div>

            <div class="comment-reply">

                <span class="pointer" @click="is_reply = !is_reply;">回复</span>

                <span class="pointer" v-if="data.reply.length > 2" @click="getMoreReply">{{ is_more ? '查看更多' : '收起' }}</span>

            </div>

        </div>

        <div v-if="is_reply" class="comment-input reply-margin fr">

            <textarea type="text" v-model="comment" placeholder="给你一个神评的机会..."></textarea>

            <div class="comment-button" @click="sendReply">回复</div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
import vImage from '@/components/image';
export default {
    name: "layout-comment-item",
    mixins: [mixin],
    components: {
        vImage
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            }
        }
    }
}
</script>

<style scoped src="./style.css"></style>
